<template>
  <div>
    <Breadcrumbs main="Beacon" title="Rule" />

    <div class="container-fluid">
      <div class="d-flex justify-content-end m-3">
        <b-button variant="primary" class="btn-pill" @click="openModal('Add')">
          <i class="icofont icofont-plus-circle"></i> Add New</b-button>
      </div>
      <ValidationObserver v-slot="{ invalid }">
        <b-modal :hide-footer="modalData.title == 'View'" content-class="rounded-1" v-model="show" body-class="p-4"
          centered :title="`${modalData.title} Rule`">
          <div class="row">
            <div v-for="(form, i) in form" :key="i" :class="`col-${form.col}`">
              <ValidationProvider :name="form.name" :rules="form.validate ? form.rule : ''" v-slot="{ errors }">
                <b-form-group :label="form.name" :label-for="form.name">
                  <template #description>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </template>
                  <v-select v-if="form.type.match('select')" id="application" label="name" :disabled="modalData.disable"
                    v-model="form.value" :multiple="form.multi" :options="form.option"></v-select>
                  <b-form-input v-else v-model="form.value" :disabled="modalData.disable" :id="form.name"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
          </div>
          <template #modal-footer>
            <b-button variant="primary" :disabled="invalid" @click="save(modalData)"><i class="fa fa-save"></i> Save
            </b-button>
          </template>
        </b-modal>
      </ValidationObserver>

      <div class="card p-4">
        <dataTableVue ref="refDataTable" :isSearch="false" :isFilter="true" :isExport="true" v-bind:data="{
                  module: 'beacon',
                  columns: columns,
                  rows: rows,
                  exportDetail: exportDetail,
                  filter_custom: 'filterCustomRule',
                }" @load="loadItems" @openModal="openModal" @deleteRow="deleteRow" />
      </div>
    </div>
  </div>
</template>

<script>
import { requestService } from './../../_services';

export default {
  data() {
    return {
      company: [],
      application: [],
      category: [],
      modalData: {
        title: null,
        disable: false,
        row: null,
      },
      show: false,
      form: [
        {
          value: '',
          col: 12,
          name: 'Rule Name',
          type: 'input',
          validate: true,
          rule: 'required|customRegex|customRegexCRLF|max_length200'
        },
        {
          value: '',
          col: 12,
          name: 'Application',
          type: 'select',
          validate: true,
          option: [],
          rule: 'required|customRegex|customRegexCRLF|max_length200'
        },
        {
          value: '',
          col: 12,
          name: 'Company',
          type: 'select',
          validate: true,
          multi: true,
          option: [],
          rule: 'required'
        },
        {
          value: '',
          col: 12,
          name: 'Category',
          type: 'select',
          validate: true,
          multi: true,
          option: [],
          rule: 'required'
        },
      ],
      columns: [
        {
          label: 'Name',
          field: 'name',
          hidden: false,
        },
        {
          label: 'Application',
          field: 'application',
          hidden: false,
        },
        {
          label: 'Company',
          field: 'company',
          hidden: false,
        },
        {
          label: 'Category',
          field: 'category',
          hidden: false,
        },
        {
          label: 'Update Date',
          field: 'updated_at',
          hidden: false,
        },
        {
          label: 'Action',
          field: 'action',
          thClass: 'custom-th-class',
          hidden: false,
        },
      ],
      rows: [],
      exportDetail: {
        fileName: 'export_rule',
        exportUrl: '',
      },
    };
  },
  watch: {
    show(newValue, oldValue) {
      if (oldValue) {
        this.form.map((item, i) => {
          this.form[i].value = '';
        });
      }
    },
  },
  async created() {
    // this.loadColumn();
    await this.loadItems();
    await this.getCompany();
    await this.getApplication();
    await this.getCategory();
  },
  methods: {
    deleteRow(value) {
      const url = `/api/rule/${value.row._id}`;
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2971FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            requestService
              .DeleteFetch('beacon', url)
              .then(() => {
                this.$swal.fire(
                  'Deleted!',
                  'Your file has been deleted.',
                  'success'
                );
                this.loadItems();
              })
              .catch((err) => {
                this.$swal.fire({
                  icon: 'error',
                  title: 'Try Again',
                  text: err,
                });
              });
          }
        });
    },
    save(value) {
      let data = this.form.map((item) => item.value);
      this.show = !this.show;
      const url = `/api/rule${value.title.match('Edit') ? '/' + value.row.row._id : ''
        }`;

      const object = {
        name: data[0],
        application_id: data[1]._id,
        company: data[2].map((item) => item._id),
        category: data[3].map((item) => item._id),
      };

      requestService
        .PostFetch('beacon', url, object)
        .then(() => {
          this.$swal.fire({
            icon: 'success',
            title: 'Rule has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          this.form.map((item, i) => {
            this.form[i].value = '';
          });
          this.loadItems();
        })
        .catch((err) => {
          this.$swal.fire({
            icon: 'error',
            title: 'Try Again',
            text: err,
          });
        });
    },
    async getCompany() {
      let url = `/api/company/all`;
      const resData = await requestService.GetFetch('beacon', url);
      const data = await resData.json();
      this.form[2].option = data.data;
    },
    async getCategory() {
      let url = `/api/category/all`;
      const resData = await requestService.GetFetch('beacon', url);
      const data = await resData.json();
      this.form[3].option = data.data;
    },
    async getApplication() {
      let url = `/api/application/all`;
      const resData = await requestService.GetFetch('beacon', url);
      const data = await resData.json();
      this.form[1].option = data.data;
    },
    openModal(value, id) {
      this.modalData.title = value;
      this.modalData.row = id;

      this.show = !this.show;

      if (!value.match('Add')) {
        this.form[0].value = id.row.name;
        this.form[1].value = id.row.application[0];
        this.form[2].value = id.row.company;
        this.form[3].value = id.row.category;
      }
      value.match('View')
        ? (this.modalData.disable = true)
        : (this.modalData.disable = false);
    },
    async loadItems(event) {
      var str = '';
      if (event != undefined) {
        for (var key in event.params) {
          if (str != '') {
            str += '&';
          }
          str += key + '=' + encodeURIComponent(event.params[key]);
        }
        this.columns.forEach((element) => {
          if (event.sortField == element.field) {
            if (
              event.sortField == 'created_at' ||
              event.sortField == 'updated_at'
            ) {
              str += '&' + 'sortField=' + event.sortField;
            } else {
              str += '&' + 'sortField=' + element.field;
            }
          }
        });
        if (event.filter != undefined) {
          for (var key in event.filter) {
            if (str != '') {
              str += '&';
            }
            str += key + '=' + encodeURIComponent(event.filter[key]);
          }
        }
      }

      var url = '/api/rule/filter?' + str;
      this.exportDetail.exportUrl = '/api/rule/export?' + str;
      return requestService
        .GetFetch('beacon', url)
        .then((response) => {
          if (response.status == 200) {
            response.text().then((text) => {
              let self = this;
              self.rows = [];
              const data = text && JSON.parse(text);
              if (data.data.data != null) {
                self.json_data = data.data.data;
                self.rows = data.data.data;
                self.$refs.refDataTable.setTotalRecords(data.data.total);
                self.$refs.refDataTable.setPages(data.data.current_page);
              } else {
                self.$refs.refDataTable.setTotalRecords(0);
                self.$refs.refDataTable.setPages(1);
              }
            });
          }
        })
        .catch((error) => {
          this.$notify({ text: error, type: 'danger' });
        });
    },
  },
};
</script>

<style></style>
